import { ViewportTypeValues } from '@contexts/viewport'

const viewportType: ViewportTypeValues = ViewportTypeValues.DESKTOP

export default viewportType
